import {Cards} from "../Card/Cards";

export let ContentArchiveProps = {
    cardLink: {
        type: Boolean,
        default: true,
    },
    contentCategory: {
        type: Object,
        default: null,
    },
    contentType: {
        options: ['page', 'post'],
        default: 'page',
    },
    slicer: {
        type: Number,
        default: 12,
    },
    itemClass: {
        default: 'col-lg-4 my-2'
    },
    waitForCategoryProp: {
        type: Boolean,
        default: false,
    },
    categoryColumnProp: {
        default: 'slug',
    },
    contentCard: {
        options: Object.keys(Cards),
        default: 'mContentCard300'
    },
    sliderPagination: {
        type: Boolean,
        default: true,
    },
    swiperPerViewSM: {
        type: Number,
        default: 2,
    },
    swiperPerViewMD: {
        type: Number,
        default: 3,
    },
    swiperPerViewLG: {
        type: Number,
        default: 4,
    },
    swiperPerViewSpaceBetweenSM: {
        type: Number,
        default: 30,
    },
    swiperPerViewSpaceBetweenMD: {
        type: Number,
        default: 30,
    },
    swiperPerViewSpaceBetweenLG: {
        type: Number,
        default: 30,
    },
    sliderGridStatus: {
        type: Boolean,
        default: false,
    },
    sliderGridRows: {
        type: Number,
        default: 2,
    },
    sliderLoop: {
        type: Boolean,
        default: false,
    }
}